"use strict";
/*!
 * Copyright 2012 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IonType = void 0;
/** Ion value type enumeration class. */
class IonType {
    constructor(
    /** The binary type ID for this Ion Type. */
    binaryTypeId, 
    /** The textual name of this type. */
    name, 
    /** Whether or not this type is a scalar value. */
    isScalar, 
    /** Whether or not this type is a `clob` or `blob`. */
    isLob, 
    /** Whether or not this type is an `int`, `float`, or `decimal`. */
    isNumeric, 
    /** Whether or not this type is a `list`, `sexp`, or `struct`. */
    isContainer) {
        this.binaryTypeId = binaryTypeId;
        this.name = name;
        this.isScalar = isScalar;
        this.isLob = isLob;
        this.isNumeric = isNumeric;
        this.isContainer = isContainer;
    }
}
exports.IonType = IonType;
